import type { GDDLEvent } from '@analytics/models';

/**
 * Creates a GDDL spec compliant event based on name and information.
 * @param eventName unique name of the event type that's being sent
 * @param eventInfo contextual information regarding the event, e.g. what variant of the event this is.
 * @param additionalData additional data to be sent or processed that is not directly tied to the event's content.
 * @returns GDDLEvent
 * @example
 * ```
 * createGddlEvent('button-hover',
 *  {
 *    variant: 'primary'
 *  },
 *  {
 *    pageInfo: {url: '/energie'},
 *    significance: 0
 *  }
 * )
 * ```
 */
export function createGDDLEvent(
  eventName: string,
  eventInfo: Record<string, any>,
  additionalData?: Record<string, any>
): GDDLEvent {
  return {
    event: eventName,
    info: eventInfo,
    ...additionalData,
  };
}
